import { useAdvancedEditorContext } from '@/pages/AdvancedEditor/context/useAdvancedEditorContext';
import { polotnoTypes } from '@/pages/AdvancedEditor/types';
import { checkPolotnoType } from '@/pages/AdvancedEditor/utils';
import styled from '@emotion/styled';
import { observer } from 'mobx-react-lite';
import { ControlRow } from '../common/ControlRow';
import {
    AlignTextControl,
    CurrentValueControl,
    FontColorControl,
    FontFamilyControl,
    FontSizeControl,
    FontStyleControl,
    TextSpacingControl,
} from './controls';

const Container = styled.div`
    padding: 20px;
    border: 1px solid ${({ theme }) => theme.colors.black[200]};
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    gap: 24px;
`;

export const ModifyText = observer(() => {
    const { store } = useAdvancedEditorContext();
    const element = store.selectedElements[0];

    if (!checkPolotnoType(element, polotnoTypes.Text)) {
        return null;
    }

    return (
        <Container data-testid="modify-text-panel">
            <CurrentValueControl />

            <ControlRow>
                Font family
                <FontFamilyControl />
            </ControlRow>

            <ControlRow>
                Font size
                <FontSizeControl />
            </ControlRow>

            <ControlRow>
                Line height
                <TextSpacingControl />
            </ControlRow>

            <ControlRow>
                Font color
                <FontColorControl />
            </ControlRow>

            <ControlRow>
                Font style
                <FontStyleControl />
            </ControlRow>

            <ControlRow>
                Alignment
                <AlignTextControl />
            </ControlRow>
        </Container>
    );
});
